import axios from 'axios'
import * as types from '../mutation-types'
import TestsService from '~/services/tests';

// state
export const state = {
  tests: [],
  test: null,
};

// getters
export const getters = {
  tests: state => state.tests,
  test: state => state.test,
};

// mutations
export const mutations = {
  [types.TESTS_FETCH_ALL] (state, tests) {
    state.tests = tests;
  },
  [types.TESTS_CLEAR] (state) {
    state.test = null;
  },
  [types.TESTS_FIND] (state, test) {
    state.test = test;
  },
  [types.TESTS_CREATE] (state, test) {
    state.tests.push(test);
  },
  [types.TESTS_UPDATE] (state, test) {
    let index = state.tests.findIndex(el => el.id === test.id);

    if (index !== -1) {
      state.tests[index] = test;
    }
  },
  [types.TESTS_REMOVE] (state, id) {
    state.tests.splice(state.tests.findIndex(c => parseInt(c.id) === parseInt(id)), 1);
  },
};

// actions
export const actions = {
  async fetchAll ({ commit }) {
    const tests = await TestsService.fetchAll();
    commit(types.TESTS_FETCH_ALL, tests);
  },
  async fetchAllFull ({ commit }) {
    const tests = await TestsService.fetchAllFull();
    commit(types.TESTS_FETCH_ALL, tests);
  },
  clearTest ({ commit }) {
    commit(types.TESTS_CLEAR);
  },
  async find ({ commit }, id) {
    const test = await TestsService.getTest(id);
    commit(types.TESTS_FIND, test);
  },
  async findFull ({ commit }, id) {
    const test = await TestsService.getTestFull(id);
    commit(types.TESTS_FIND, test);
  },
  async fetchFullTest ({ commit }, id) {
    const test = await TestsService.getTestFull(id);
    commit(types.TESTS_FIND, test);
  },
  async create ({ commit }, form) {
    const test = await TestsService.createTest(form);
    commit(types.TESTS_CREATE, test);
  },
  async update ({ commit }, form) {
    const test = await TestsService.updateTest(form);
    commit(types.TESTS_UPDATE, test);
  },
  async remove ({ commit }, id) {
    await TestsService.removeTest(id);
    commit(types.TESTS_REMOVE, id);
  },
};
